<template>
    <v-container>
        <v-card>
            <v-card-title>Laravel Log Viewer</v-card-title>
            <v-card-text>
                <pre v-if="log">{{ log }}</pre>
                <v-alert v-if="error" type="error">{{ error }}</v-alert>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            log: null,
            error: null
        };
    },
    created() {
        this.fetchLog();
    },
    methods: {
        fetchLog() {
            axios
                .get('/v2/system/logs')
                .then(response => {
                    this.log = response.data.log;
                })
                .catch(error => {
                    this.error =
                        'Error fetching log: ' +
                        (error.response?.data?.error || error.message);
                });
        }
    }
};
</script>
